import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

export type SetGameTagsParams = {
  provider: string;
  game_id: string;
  tag_ids: string[];
};

export async function setGameTags({
  provider,
  game_id,
  tag_ids,
}: SetGameTagsParams): Promise<void> {
  const token = JSON.parse(localStorage.getItem("token") ?? "null");
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const url = API_ROUTES.SET_GAME_TAGS
    .replace("{provider}", encodeURIComponent(provider))
    .replace("{game_id}", encodeURIComponent(game_id));

  const { data: responseBody } = await instance.post(url, { tag_ids });
  if (responseBody?.success === false) {
    throw new Error(responseBody?.message || "Failed to set tags");
  }
}
